<template>
  <transition name="fade">
    <div
      v-if="val"
      class="pop"
      :class="{ show: val, hide: !val }"
      v-click-outside="onClickOutside"
    >
      <CustomIcon name="messenger" size="4" color="#4e4098" />
      <div style="margin-left: 3rem">
        <div class="protip">pro tip</div>
        <div class="protiptext">
          <slot></slot>
        </div>
      </div>
      <div class="popUpClose" style="top:1.5rem;right:1.5rem" @click="onClickOutside">
          <CustomIcon name="close-cross" size="1.4" color="#8f8f8f"/>
      </div>
    </div>
  </transition>
</template>

<script>
import vClickOutside from "v-click-outside";
import CustomIcon from "../global-components/customIcon";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    CustomIcon,
  },
  data() {
    return {
      val: false,
    };
  },
  methods: {
    onClickOutside() {
      if (this.val) this.val = false;
    },
    open() {
      this.val = true;
    },
  },
};
</script>
<style scoped>
.pop {
  position: relative;
  content: " ";
  background-color: white;
  flex-direction: row;
  justify-content: start;
  padding: 2.4rem;
  z-index: 999;
  border: #1c56ac solid 0.1rem;
  border-radius: 0.7rem;
  box-shadow: 10px 10px 20px 0 rgba(0, 0, 0, 0.16);
  max-width: 60.4rem;

  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
}
.pop:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-width: 0 11px 13px;
  border-color: #ffffff transparent;
  display: block;
  width: 0;
  z-index: 1;
  top: -13px;
  left: 10%;
}

.pop:before {
  content: "";
  position: absolute;
  border-style: solid;
  border-width: 0 11px 13px;
  border-color: #1c56ac transparent;
  display: block;
  width: 0;
  z-index: 0;
  top: -14px;
  left: 10%;
}
.protip {
  color: #ffb507;
  margin-bottom: 1rem;
  font-style: italic;
  text-align: left;
}
.protiptext {
  color: #707070;
  font-size: 1.2rem;
  text-align: left;
}
.show {
  display: flex;
  transition: width 2s linear 1s;
}
.hide {
  display: none;
  transition: width 2s linear 1s;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>